import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import {
  faTrashAlt,
  faFile,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import loadConfig from "../../Services/Api/ApiServices";
// import loadConfig from "../../Services/apiService";

export default function AttachmentASFH(props) {
  const [selectedFiles, setSelectedFiles] = useState([]); // Independent per instance
  const [singleFile, setSingleFile] = useState(props.singleFile); // Independent per instance
  const inputRef = useRef(null);
  const [dataJsonObject, SetDataJsonObject] = useState();

  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);


  // When Clear props is true clear the attachment that has been uploaded
  useEffect(() => {
    if (props.clear) {
      setSelectedFiles([]);
      setSingleFile(null);
    }
  }, [props.clear]);

  //     text="انقر للإضافة مرفق"
  //     id = "file-1"
  //     title="إضافة مرفق"
  //     disabled={true}
  //     show={true}
  //     clear={false}
  //     readOnly={true}
  // Handle file selection for single file uploads
  const handleSingleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first file selected;
    const allowedExtensions = [
      "pdf",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "jpg",
      "jpeg",
      "png",
    ]; // Allowed file extensions

    // to make the limit size of the attachment is 10 MB
    const maxFileSize = 10 * 1024 * 1024; // 10 MB in bytes
    // Extract the file extension
    const extension = file.name.split(".").pop().toLowerCase();

    //   // const extension = file.name.split(".").pop().toLowerCase();
    //   if (allowedExtensions.includes(extension)) {
    //     props.onChange(e);
    //     setSingleFile(file);
    //   } else {
    //     Swal.fire({
    //       title: "خطأ",
    //       text: `الملف غير مدعوم ، الملفات المدعومة هي : ${allowedExtensions.join(
    //         " ، "
    //       )}`,
    //       icon: "error",
    //       confirmButtonText: "موافق",
    //     }).then(() => {
    //       // Reset the input value so the same file can be re-uploaded if needed
    //       e.target.value = null;
    //     });
    //   }
    // };
    // Validate file extension
    if (!allowedExtensions.includes(extension)) {
      Swal.fire({
        title: "خطأ",
        text: `الملف غير مدعوم ، الملفات المدعومة هي : ${allowedExtensions.join(
          " ، "
        )}`,
        icon: "error",
        confirmButtonText: "موافق",
      }).then(() => {
        e.target.value = null; // Reset the input value
      });
      // Validate file size
    } else if (file.size > maxFileSize) {
      Swal.fire({
        title: "خطأ",
        text: "حجم الملف كبير ، يجب ان يكون حجم المرفق 10 MB او اقل.",
        icon: "error",
        confirmButtonText: "موافق",
      }).then(() => {
        e.target.value = null; // Reset the input value
      });
    } else {
      // File is valid
      props.onChange(e); // Trigger the parent onChange handler
      setSingleFile(file); // Update the state with the selected file
    }
  };
  // const removeSingleFile = () => {
  //   Swal.fire({
  //     title: "هل انت متأكد من حذف هذا المرفق ؟",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#0056b3",
  //     cancelButtonColor: "#d33",
  //     cancelButtonText: "الغاء",
  //     confirmButtonText: "نعم ، قم بالحذف !",
  //     customClass: {
  //       container: "custom-swal-container",
  //       popup: "custom-swal-width",
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       setSingleFile(null);
  //       Swal.fire({
  //         title: " تم الحذف !",
  //         text: "تم حذف المرفق بنجاح .",
  //         confirmButtonText: "موافق",
  //         icon: "success",
  //         customClass: {
  //           container: "custom-swal-container",
  //           popup: "custom-swal-width",
  //         },
  //       });
  //     }
  //   });
  // };

  // const openFileInNewTabFront = (file) => {
  //   // const fileURL = URL.createObjectURL(file);
  //   window.open(
  //     `http://localhost:52386/${props.AttachementType}/` + singleFile
  //   );
  // };

  // Open the file in a new tab
  const openFileInNewTabFront = (file) => {
    // Check if `file` is an instance of File (from frontend)
    if (file instanceof File) {
      // For files uploaded in the frontend
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
    } else {
      // For files received from the backend
      // If `file` is a string (from backend)
      window.open(
        `${dataJsonObject.domainUrl}/${props.AttachementType}/` + singleFile,
        "_blank"
      );
    }
  };

  // Truncate the file name for display purposes
  const truncateFileName = (fileName) => {
    // return fileName.length > 50 ? fileName.slice(0, 30) + "..." : fileName;
    return "عرض المرفق";
    //"عرض المرفق"
  };

  return (
    <>
      {props.show && (
        <>
          {/* <a
            className="showFile"
            title={"kkkkkkk"}
            href={`http://localhost:52386/commercialRegister/` + singleFile}
            target="_blank"
          >
            <span className="attacheNameIcon">عرض المرفق</span>

            {/* {commercialRegister} */}
          {/* <span>
              <i class="bi bi-folder2-open" id="showIcon">
                {" "}
              </i>
            </span>
          </a> */}
          {/* Upload Single Attachment */}
          <label
            className="custum-file-upload"
            htmlFor={`singleFile-${props.id}`} // Use unique ID if necessary
            title={props.title}
          >
            <div className="icon">
              <FontAwesomeIcon icon={faFile} />
              &nbsp;
            </div>
            <div className="text">
              <span>{singleFile ? props.textEdit?props.textEdit:"انقر لتعديل المرفق" : props.text?props.text:"انقر لاضافة مرفق"}</span>
            </div>
            {props.showValidationMessage && (
              <span
                className="validation-icon"
                data-tooltip={props.validationMessage}
              >
                <FontAwesomeIcon icon={faCircleExclamation} />
                &nbsp;
              </span>
            )}
            <input
              type="file"
              id={`singleFile-${props.id}`} // Unique ID for each input
              title={singleFile ? props.title : "انقر لإضافة المرفق"}
              disabled={props.disabled}
              onChange={handleSingleFileChange}
            />
          </label>
        </>
      )}
      {singleFile && (
        <div className="file-list">
          <div className="file-item">
            <div className="file-details">
              <span
                title="عرض المرفق"
                onClick={() => openFileInNewTabFront(singleFile)}
                className="file-name"
                style={{ color: "black", cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={faFile} />
                &nbsp; {truncateFileName(singleFile)}
              </span>
              <button
                // className="open-file"
                // className="donteffect-button"
                title="عرض"
                type="button"
                // className="no-background"
                // onClick={removeSingleFile}
                onClick={() => openFileInNewTabFront(singleFile)}
              >
                {/* <div class="donteffect-container">
                  <div class="donteffect-folder donteffect-folder_one"></div>
                  <div class="donteffect-folder donteffect-folder_two"></div>
                  <div class="donteffect-folder donteffect-folder_three"></div>
                  <div class="donteffect-folder donteffect-folder_four"></div>
                </div>
                <div class="donteffect-active_line"></div>  */}
                {/* <span class="donteffect-text">File Explorer</span>
                {/* <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ color: "red", marginRight: "5px" }}
                  
                /> */}
                {/* <span className="file-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 71 67"
                  >
                    <path
                      stroke-width="5"
                      stroke="black"
                      d="M41.7322 11.7678L42.4645 12.5H43.5H68.5V64.5H2.5V2.5H32.4645L41.7322 11.7678Z"
                    ></path>
                  </svg>
                  <span className="file-front"></span>
                </span>
                عرض المرفق */}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
